export const ClinicType = {
  STANDALONE: "STANDALONE",
  CHAIN: "CHAIN",
};

export const Status = {
  PENDING: "PENDING",
  LOCKED: "LOCKED",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
};
